import { compareDate, dateFormat, formattedDate, toDate } from "@/app/utils/DayJS";
import { Race } from "./race";
import { RaceNo } from "../common/base";
import { raceTemplate } from "@/app/utils/constant/template";
import { meetingStatus, pmPoolStatus } from "../../constant/statusSet";
import { LANGTYPE_EN, LangType } from "../../LanguageContext";
import { orderBy } from "lodash";

export class Meeting {
  id!: string;
  displayName!: string;
  hasChildren?: boolean;
  path?: string;
  season?: string;
  presite?: boolean;
  racedayImage?: IImageField;
  racedayName?: string;
  meetingDate?: IDateField;
  meetingCountry?: string;
  countryName?: string;
  countryNameEn?: string;
  meetingVenueCode?: string;
  carnivalInfo?: string;
  racecourseName?: string;
  noOfRaces?: string;
  mainRace?: string;
  meetingDescription?: string;
  MeetingSummaryMenu?: ITargetListField;  
  RaceImages?: ITargetListField;
  races?: IRace[];
  finalDeclarationsAndBarrierDraws?: string;

  RaceMeetingProfile?: IRaceMeetingProfile; // from QIDS
  status?: string; // from QIDS
  constructor(data?: IMeeting){    
    this.id = data?.id || ''
    this.displayName = data?.displayName || ""
    this.hasChildren = data?.hasChildren
    this.path = data?.path
    this.season = data?.season?.name
    this.presite = data?.presite?.boolValue
    this.racedayImage = data?.racedayImage
    this.racedayName = data?.racedayName?.value
    this.meetingDate = data?.meetingDate
    this.meetingCountry = data?.meetingCountry?.value
    this.countryName = data?.countryName?.value
    this.countryNameEn = data?.countryNameEn?.value
    this.meetingVenueCode = data?.meetingVenueCode?.value?.toUpperCase()
    this.carnivalInfo = data?.carnivalInfo?.value
    this.racecourseName = data?.racecourseName?.value
    this.noOfRaces = data?.noOfRaces?.value
    this.mainRace =  this.isValidTemplateItem([raceTemplate.ID], data?.mainRace?.targetItem) ? data?.mainRace?.targetItem?.displayName : undefined
    this.meetingDescription = data?.meetingDescription?.rendered
    this.MeetingSummaryMenu = data?.MeetingSummaryMenu
    this.RaceImages = data?.RaceImages
    this.races = orderBy(data?.races?.[0]?.raceInfo, (race)=>new RaceNo(race.displayName), ['asc']) || []
    this.RaceMeetingProfile = data?.RaceMeetingProfile
    this.finalDeclarationsAndBarrierDraws = data?.finalDeclarationsAndBarrierDraws?.url
    this.status = data?.status;
  }

  /**
   * Check if target item is valid template
   * @Param skipCheckVaildSubItem - true: skip checking if targetItem must be one of the children item under meeting
   */
  isValidTemplateItem(ids: string[], targetItem?: {path?: string, template?:{id?: string}}, skipCheckVaildSubItem?: boolean){
    const checkValidTemplate = ids.includes(targetItem?.template?.id || '')
    const checkValidItem = (skipCheckVaildSubItem && targetItem) || (targetItem?.path?.replace(this.path || '', '').length || 0) < (targetItem?.path?.length || 0)
    return checkValidTemplate && checkValidItem
  }

  getTitle(selectedRace?: Race){
    const venueCode = selectedRace?.venueCode || selectedRace?.displayName || ""
    return `${this.presite ? (this.racedayName || "") : (selectedRace?.raceName || "")}${venueCode ? ` (${venueCode})` : ""}` 
  }

  getQIDSMeetingID(){
    return `${formattedDate(toDate(this.meetingDate?.value, dateFormat.cms.datetime), "YYYYMMDD")}${this.meetingVenueCode?.toUpperCase()}` 
  }

  isPresite(){
    return this.presite === true 
  }

  isPostRace(bizDate: Date){
    const postRaceMtStatus = [meetingStatus.CLOSED, meetingStatus.ABANDON, meetingStatus.ABANDON_PARTIAL];
    return compareDate(formattedDate(bizDate, "YYYY-MM-DD"), formattedDate(toDate(this.meetingDate?.value, dateFormat.cms.datetime), "YYYY-MM-DD"), "after", false) && postRaceMtStatus.includes(this.RaceMeetingProfile?.status?.toUpperCase() || '')
  }

  isBeforeStartSell() {
    const preRacePmPoolSt = [pmPoolStatus.INITIAL, pmPoolStatus.DEFINED];
    return !this.RaceMeetingProfile?.pmPools?.some(x => !preRacePmPoolSt.includes(x.status || ""))
  }
  isMeetingFinished() {
    const postRaceMtStatus = [meetingStatus.CLOSED, meetingStatus.ABANDON, meetingStatus.ABANDON_PARTIAL];
    return postRaceMtStatus.includes(this.RaceMeetingProfile?.status?.toUpperCase() || '')
  }

  displayNameSuffix() {
    return this.displayName.split("_")[1]?.toUpperCase()
  }

  venueCodeForSearchParam(){
    // refer to PRJ2555-974
    // for presite meeting, use displayName suffix
    const presiteSearchParam = this.displayNameSuffix()
    // for non-presite meeting, use venueCode
    const searchParam = this.meetingVenueCode
    return (this.presite ? presiteSearchParam : searchParam) || ''; 
  }

  isMatchWithVenueCode(venueCode?: string){
    return this.venueCodeForSearchParam() === venueCode?.toUpperCase();
  }

  generateTabLabel(){
    const msg = this.meetingVenueCode ? ` (${this.meetingVenueCode}${this.countryName ? " " + this.countryName : ""})` : this.countryName ? ` (${this.countryName})` : '';
    return (this.racedayName + msg) ? (this.racedayName + msg) : this.displayName
  }

  setRaces(races?: IRace[]){
    this.races = orderBy(races, (race)=>new RaceNo(race.displayName), ['asc']) || [];
  }
}